import { HttpClient, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CotizacionesService {

  constructor(private http: HttpClient) { }


  getPrintableQuote(loanId: string, data: any, command: any,outputFormat: any) {
    const httpParams = new HttpParams().set('command', command).set('outputFormat', outputFormat);
    return this.http.post(`/loans/${loanId}/transactions`, data, {params: httpParams, responseType: "blob"})
    .pipe( catchError(error => {
        console.log("Quotation generation failed");
        return of(true)
      }));
  }

}